import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Coordinates, PeliasResponse } from '..';
import { Observable } from 'rxjs';
import { LanguageService } from '@shared/services';

@Injectable({
  providedIn: 'root'
})
export class ReverseGeocodingService {
  
  protected basePath = `${environment.otpUrl}reverse`;
  private language = inject(LanguageService).currentLanguage;

  constructor(private httpClient: HttpClient) { }

  public reverseGeocoding(coordinates: Coordinates, lang: string = this.language() ):Observable<PeliasResponse>{
    const params = new HttpParams()
    .set('point.lat', coordinates.lat)
    .set('point.lon', coordinates.lng)
    .set('lang', lang);


    return this.httpClient.get<PeliasResponse>(`${this.basePath}`, { params });
  }

}
